import { AbstractLocalDataAccessLayer } from "@/lib/utility/data/local-data-access-layer.abstract";
import { ITag, Tag } from "@/models/tag.entity";

export const TagDataAccessLayer = new (class extends AbstractLocalDataAccessLayer<ITag, ""> {
  getIdentifier(entity: ITag): string {
    return (entity as ITag).id;
  }

  mapEntity(entity: ITag): ITag {
    return new Tag(entity);
  }
})();
